<template>
  <div class="header-bar-container">
    <Slide>
      <router-link to="/" tag="div" class="nav-item">
        <!--img class="icon" src="../assets/info.png"/-->
        Start
      </router-link>
      <router-link to="/menu" tag="div" class="nav-item">
        Hauptmenü
      </router-link>
      <router-link to="/programm" tag="div" class="nav-item">
        Programm
      </router-link>
      <router-link to="/kandidaten" tag="div" class="nav-item">
        Kandidaten
      </router-link>
      <div class="nav-item">
        <a class="nav-item" href="https://www.gruene-weiden.de">
          B90/DIE GRÜNEN Weiden
        </a>
      </div>

      <!-- <router-link to="/sdgs" tag="div" class="nav-item">
        <img class="icon" src="../assets/info.png"/>
        Nachhaltigkeit und SDGs
      </router-link>
      <router-link to="/poll" tag="div" class="nav-item">
        <img class="icon" src="../assets/poll.png"/>
        Teste dich selbst
      </router-link>
      <router-link to="/tipps" tag="div" class="nav-item">
        <img class="icon" src="../assets/tipps.png"/>
        Das kannst du tun
      </router-link>
      <router-link to="/highscores" tag="div" class="nav-item">
        <img class="icon" src="../assets/results.png"/>
        Nachhaltigkeits-Bestenliste
      </router-link> -->
      <router-link to="/contact" tag="div" class="nav-item">
        <!--img class="icon" src="../assets/results.png"/-->
        Impressum
      </router-link>
      <div>Version: 0.2.7</div>
    </Slide>
  </div>
</template>

<script>
import { Slide } from 'vue-burger-menu' 

export default {
  name: 'HeaderBar',
  components: {
    Slide
  },
  data() {
    return {
      key: "value"
    }
  },
  methods: {
    name() {

    }
  },
}
</script>

<style lang="scss">
@import '@/assets/shared.scss';
.header-bar-container {
  height: 100px;
}
.nav-item {
  line-height: 30px;
  cursor: pointer;
  text-align: left;
  text-decoration: none;
  color: #b8b7ad;
}

.icon {
  max-width: 30px;
  max-height: 30px;
  margin-right: 10px;
}
</style>
